module.exports = __webpack_public_path__ + "static/img/sp_bf_87@2x.fa6d08c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sp_bf_87@2x.png
// module id = 898
// module chunks = 1